import { defineStore } from 'pinia'

export const useDashboardStore = defineStore('dashboardStore', {
  state:() => ({
    dashboard_year: null,
    dashboard_months: [],
  }),
  actions : {
    getMonths(){
        this.dashboard_year = new Date().getFullYear();
        for (let month = 0; month < 12; month++) {
            const date = new Date(this.dashboard_year, month, 1);
            const monthName = date.toLocaleString('default', { month: 'long' });
            this.dashboard_months.push(monthName);
        }  
    },
  }
})